import React from 'react';
import { LinkStyleButton, PrimaryButton } from '../../../components/Buttons';
import windowService from '../../../services/windowService';
import { LicenseAlreadyGrantedContainer } from './OnboardingElements';

export const PreviewAlreadyGranted = () => {
  return (
    <LicenseAlreadyGrantedContainer>
      <h2>You Have Already Signed Up For This Preview</h2>
      <p>Use the button below to access your preview</p>
      <PrimaryButton data-qa-hook="redirectToSubscription" onClick={() => windowService.redirectTo('/bible-studies')}>
        Go to Bible Studies
      </PrimaryButton>
    </LicenseAlreadyGrantedContainer>
  );
};

export const LicenseAlreadyGranted = ({ subscriptionUrl }: { subscriptionUrl?: string }) => {
  return (
    <LicenseAlreadyGrantedContainer>
      <h2>You Have Already Signed Up For This Trial</h2>
      <p>Use the button below to get started with your subscription</p>

      {subscriptionUrl && (
        <PrimaryButton
          data-qa-hook="redirectToSubscription"
          onClick={() => windowService.openUrlInSameTab(subscriptionUrl)}
        >
          View Subscription Options
        </PrimaryButton>
      )}

      <LinkStyleButton
        data-qa-hook="redirectToBibleStudies"
        onClick={() => {
          windowService.redirectTo('/bible-studies');
        }}
      >
        Explore Other Bible Studies
      </LinkStyleButton>
    </LicenseAlreadyGrantedContainer>
  );
};
